module.exports = __webpack_public_path__ + "static/media/defaultLetterHead.e181d28c.jpg";